import { useNavigate } from "react-router-dom";
import { FaExclamationTriangle } from "react-icons/fa";

interface ProductNotFoundProps {
    title?: string;
    message?: string;
    buttonText?: string;
    onGoBack?: () => void;
    className?: string;
}

export default function ProductNotFound({
    title = "Oops! Product Not Found",
    message = "The product you're looking for doesn't exist or may have been moved. Try browsing our catalogue.",
    buttonText = "Go Back",
    onGoBack,
    className = "",
}: ProductNotFoundProps) {
    const navigate = useNavigate();
    const handleGoBack = onGoBack ?? (() => navigate(-1));
    return (
        <div className={`flex flex-col items-center justify-center min-h-screen  w-full bg-gradient-to-b from-[#f8fafc] to-[#f2f2f2] px-4 ${className}`}>
            <div className="text-center max-w-md">
                <FaExclamationTriangle className="text-6xl text-gray-400 mb-4 mx-auto" aria-hidden="false" />
                <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">{title}</h1>
                <p className="text-lg text-gray-600 mb-6">{message}</p>
                <button
                    className="bg-harvey-red text-white font-semibold px-8 py-3 rounded-lg shadow hover:bg-harvey-red/90 transition"
                    onClick={handleGoBack}
                >
                    {buttonText}
                </button>
            </div>
        </div>
    );
}